import { createContext } from 'react';

export interface ChartAnimationsContextType {
  chartAnimationsEnabled: boolean;
  toggleChartAnimations: () => void;
}

export const ChartAnimationsContext = createContext<ChartAnimationsContextType | undefined>(undefined);
